import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const isPromoCode = (
    state: IApplicationState
): boolean => {
    const { route } = state.router;
    return route === ERoutes.PROMO_CODE || route === ERoutes.PROMO_CODE_2;
}
